import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLayoutLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"layout-left, margin, padding"} maskId="square-filled-radius-0-stroke-1-IconLayoutLeft"><path d="M6 21H21V3H6V21Z" fill="currentColor"/><path d="M3 21H4V3H3V21Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconLayoutLeft;
